import { ColoursObj } from '@eventr/common-storybook'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { selectorOriginalItinCodes } from '../../../state/itineraryState/itineraryMap.slice'
import { SectionButton } from './sectionButton'

export const PublicItinsButton = () => {
    const publicItinCodes = useBoundStore(selectorOriginalItinCodes)
    if (!publicItinCodes?.length) return null
    return (
        <SectionButton
            claimPaths={[`/`]}
            claims={['full']}
            elementID={'publicItinsButton'}
            colour={ColoursObj.coreBrights.tertiary}
            onClick={() => {
                window.pushPath('/edit/publicItins')
            }}
            icon={'Add'}
            text={i18n.t('edit-itinerary.section-selection.public-itineraries')}
        />
    )
}
